import { useState, useEffect } from 'react';
import { Header } from '../../components/Header/index';
import { Load } from '../../components/Load/index';
import { Sidebar } from '../../components/Sidebar';

export function Home() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkToken = () => {
      const token = localStorage.getItem('token');

      if (token) {
        setIsLoading(false);
      }
    };
    checkToken();

    const intervalId = setInterval(checkToken, 1000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div>
      <Load isLoading={isLoading} />

      {!isLoading && (
        <>
          <Sidebar />
          <Header route='./' />
          <div className="main">
            <p></p>
          </div>
        </>
      )}
    </div>
  );
}
